/**
 * Labstep
 *
 * @module prosemirror/nodes/experiment
 * @desc Experiment node
 */

import type { LabstepNode } from 'labstep-web/prosemirror/nodes/types';
import { getAttrsForId } from 'labstep-web/prosemirror/nodes/utils';
import type { Node as ProseMirrorNode } from 'prosemirror-model';

const key = 'experiment';

export const NodeExperiment: LabstepNode = {
  key,
  spec: {
    attrs: {
      id: {},
    },
    inline: true,
    group: 'inline',
    marks: '',
    draggable: true,
    parseDOM: [{ tag: 'span', getAttrs: getAttrsForId(key) }],
    toDOM(node: ProseMirrorNode) {
      const { id } = node.attrs;
      return ['span', { [`data-${NodeExperiment.key}-id`]: id }];
    },
  },
};
